const infoSubtleLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.25" stroke-width="1.5"/><path stroke-width="0" d="M11.25 7h1.5v1.5h-1.5zm0 3.25h1.5v7h-1.5z"/></svg>',
};

export { infoSubtleLarge as default };
